/* Iniziali Atelier nel carrello: «Togli le iniziali» e controllo d'integrità delle righe annidate.
   - capo con iniziali senza la sua riga «Iniziali Atelier» → torna capo semplice (nessuna iniziale non pagata)
   - riga «Iniziali Atelier» senza capo → tolta
   - riga «Iniziali Atelier» con quantità diversa dal capo → riportata alla quantità del capo
   Dipende da lq-iniziali-core.js (findOrphans). Config: window.LqInizialiCart = { variantId }. */
(function () {
  'use strict';

  if (window.LqInizialiCartReady) return;
  window.LqInizialiCartReady = true;

  var MIN_GAP_MS = 2000;
  var busy = false;
  var lastFix = 0;

  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  function post(path, body) {
    return fetch(root() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(path + ' ' + r.status);
      return r.json();
    });
  }

  function getCart() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function addPlain(op) {
    var prevSkip = window.upcartShouldSkipAddToCartInterceptor;
    window.upcartShouldSkipAddToCartInterceptor = true;
    var item = { id: op.id, quantity: op.quantity };
    if (op.properties) item.properties = op.properties;
    if (op.selling_plan) item.selling_plan = op.selling_plan;
    return post('cart/add.js', { items: [item] }).then(function (res) {
      window.upcartShouldSkipAddToCartInterceptor = prevSkip;
      return res;
    }, function (err) {
      window.upcartShouldSkipAddToCartInterceptor = prevSkip;
      throw err;
    });
  }

  function refresh() {
    document.dispatchEvent(new CustomEvent('apps:product-added-to-cart', { detail: { source: 'lq-iniziali' } }));
    try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) { /* UpCart assente */ }
    if (/\/cart\/?$/.test(location.pathname)) location.reload();
  }

  /* Sostituisce il capo personalizzato (e la sua riga annidata) con lo stesso capo senza iniziali.
     Ordine sicuro (core.plainReplacementOps): prima si aggiunge il semplice, poi si toglie il personalizzato.
     Sui pacchetti (tute due pezzi) la riga Iniziali non è annidata: si toglie esplicitamente. */
  function replaceWithPlain(item, cartItems) {
    var core = window.LqIniziali;
    var ops = core.plainReplacementOps(item);
    var cfg = window.LqInizialiCart || {};
    core.unnestedChildKeys(cartItems || [], item, cfg.variantId).forEach(function (key) {
      ops.push({ type: 'change', key: key, quantity: 0 });
    });
    return ops.reduce(function (p, op) {
      return p.then(function () {
        return op.type === 'add' ? addPlain(op) : post('cart/change.js', { id: op.key, quantity: op.quantity });
      });
    }, Promise.resolve());
  }

  function sessionStore() {
    try { return window.sessionStorage; } catch (e) { return null; }
  }

  function checkIntegrity() {
    var core = window.LqIniziali;
    var cfg = window.LqInizialiCart;
    if (!core || !cfg || !cfg.variantId || busy || Date.now() - lastFix < MIN_GAP_MS) return Promise.resolve();
    busy = true;
    return getCart().then(function (cart) {
      var issues = core.findOrphans(cart.items, cfg.variantId);
      var byKey = {};
      cart.items.forEach(function (item) { byKey[item.key] = item; });
      var jobs = [];
      issues.orphanParents.forEach(function (key) {
        var item = byKey[key];
        jobs.push(function () { return replaceWithPlain(item, cart.items); });
      });
      issues.orphanChildren.forEach(function (key) {
        jobs.push(function () { return post('cart/change.js', { id: key, quantity: 0 }); });
      });
      issues.wrongQuantity.forEach(function (fix) {
        jobs.push(function () { return post('cart/change.js', { id: fix.key, quantity: fix.quantity }); });
      });
      if (!jobs.length) return null;
      if (!core.autoFixAllowed(sessionStore(), Date.now())) return null;
      lastFix = Date.now();
      return jobs.reduce(function (p, job) { return p.then(job); }, Promise.resolve()).then(refresh);
    }).catch(function () { /* il carrello resta com'è: nessuna correzione parziale ripetuta */ }).then(function () {
      busy = false;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-lq-remove-initials]');
    if (!btn) return;
    e.preventDefault();
    if (busy) return;
    busy = true;
    btn.setAttribute('aria-busy', 'true');
    lastFix = Date.now();
    getCart().then(function (cart) {
      var item = cart.items.find(function (line) { return line.key === btn.getAttribute('data-key'); });
      if (!item) throw new Error('Riga non più presente');
      return replaceWithPlain(item, cart.items);
    })
      .then(refresh)
      .catch(function () { btn.removeAttribute('aria-busy'); })
      .then(function () { busy = false; });
  });

  document.addEventListener('apps:product-added-to-cart', function (e) {
    if (e.detail && e.detail.source === 'lq-iniziali') return;
    setTimeout(checkIntegrity, 300);
  });

  window.LqInizialiCartCheck = checkIntegrity;
  /* Al caricamento controlla solo se il carrello ha già righe Atelier (calcolato in Liquid): nessuna richiesta in più altrimenti. */
  if (window.LqInizialiCart && window.LqInizialiCart.hasAtelier) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', checkIntegrity);
    else checkIntegrity();
  }
})();
